import React from 'react';
import HomeLoader from './HomeLoader';
import KimemHomeLoader from './KimemLoader';
import { HomeLoadingTemplate } from '@appConfig';
export default function HomeLoadingWrapper({
  template = HomeLoadingTemplate.LENGO,
  ...rest
}) {
  if (template == HomeLoadingTemplate.LENGO) return <HomeLoader {...rest} />;
  if (template == HomeLoadingTemplate.KIMEM)
    return <KimemHomeLoader {...rest} />;
  return <HomeLoader {...rest} />;
}
